import { all } from "redux-saga/effects";
import getBestSaleProduct from "./getBestSaleProduct";
import getCRMInfoSplash from "./getCRMInfoSplash";
import getCRMInfo from "./getCRMInfo";
import getCRMRewardDetail from "./getCRMRewardDetail";
import postSignatureRewardConfirm from "./postSignatureRewardConfirm";

export const homePageSaga = function* root() {
	yield all([
		getBestSaleProduct(),
		getCRMInfoSplash(),
		getCRMInfo(),
		getCRMRewardDetail(),
		postSignatureRewardConfirm()
	]);
};
